import React from 'react';

import CSSModules from 'react-css-modules';

import type {TickBoxProps} from '..';
import Text from '../../../../TextComponents/Text';

import styles from './styles.module.scss';

const TickBoxContentComponent = (props: TickBoxProps) => {
  const {checked, isPreviewMode, altText, index} = props;

  if (isPreviewMode) {
    return null;
  }

  if (checked && !isPreviewMode) {
    return (
      <img
        styleName='check-img'
        src='/resources/img/icn_tick.svg'
        {...(altText ? {alt: altText} : {})}
      />
    );
  }

  if (typeof index === 'number') {
    return (
      <span styleName='check'>
        <Text size='s' colour='white' weight='bold' inline>
          {index}
        </Text>
      </span>
    );
  }

  return null;
};

export const TickBoxContent = CSSModules(TickBoxContentComponent, styles);
